/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 07.03.2015
 */

lmApp
  .service('MetadataService', ['$templateCache', '$rootScope', '$q', '$compile', '$timeout', '$http', 'AssetService', 'ModalWindowService', 'ValidatorService', 'ImportService',
    function ($templateCache, $rootScope, $q, $compile, $timeout, $http, AssetService, ModalWindowService, ValidatorService, ImportService) {
      var service = {};

      service.GetPlatformIcon = function (platform) {
        var iconName;
        var extid = platform.extid || platform.ext_id || platform.type;

        switch (extid) {
          case 'smarttv':
            iconName = 'monitor-multiple';
            break;

          case 'fire tv':
            iconName = 'monitor-multiple';
            break;

          case 'roku':
            iconName = 'monitor-multiple';
            break;

          case 'tvos':
            iconName = 'monitor-multiple';
            break;

          case 'android':
            iconName = 'android';
            break;

          case 'ios':
            iconName = 'apple';
            break;

          case 'stb':
            iconName = 'nest-protect';
            break;

          case 'dune':
            iconName = 'nest-protect';
            break;

          case 'ottweb':
            iconName = 'web';
            break;

          default:
            iconName = '';
            break;
        }

        return iconName;
      };

      service.GetPlatformName = function (platform) {
        var title;

        var extid = platform.extid || platform.ext_id || platform.type;

        switch (extid) {
          case 'dune':
            title = 'DuneHD-102 (DVB Hybrid)';
            break;

          case 'android':
            title = 'Android';
            break;

          case 'android tv':
            title = 'Android TV';
            break;

          case 'fire tv':
            title = 'Fire TV';
            break;

          case 'roku':
            title = 'Roku';
            break;

          case 'tvos':
            title = 'TV OS';
            break;

          case 'ios':
            title = 'iOS';
            break;

          case 'stb':
            title = 'STB ';
            break;

          case 'smarttv':
            title = 'SmartTV';
            break;

          case 'ottweb':
            title = 'PC/MAC';
            break;

          default:
            title = platform.title || platform.name;
            break;
        }

        return title;
      };

      service.GetPlatformColor = function (platform) {
        var extid = platform.extid || platform.ext_id;

        switch (extid) {
          case 'android':
            return '#f44336';

          case 'ios':
            return '#2196f3';

          case 'ottweb':
            return '#4caf50';

          case 'smarttv':
            return '#ffeb3b';

          case 'android tv':
            return '#6db355';

          case 'fire tv':
            return '#f44204';

          case 'roku':
            return '#622b8c';

          case 'tvos':
            return '#c22ebe';

          default:

            return randomColor();
        }
      };

      service.GetPlatformApp = function (platform) {
        var app;

        var extid = platform.extid || platform.ext_id;

        switch (extid) {
          case 'smarttv':
            app = 'stocksmart';
            break;

          case 'android':
            app = 'stockand';
            break;

          case 'ios':
            app = 'stockios';
            break;

          case 'stb':
            app = 'stockstb';
            break;

          case 'ottweb':
            app = 'stockweb';
            break;

          default:
            app = '';
            break;
        }

        return app;
      };


      service._STREAM_TYPES_ATTRS = {
        'dash': {
          title: 'DASH',
          placeholder: 'Example: http://transcoder.net/content/output.mpd'
        },
        'hls': {
          title: 'HLS',
          placeholder: 'Example: http://transcoder.net/content/playlist.m3u8'
        },
        'dash_live': {
          title: 'DASH Live',
          placeholder: 'Example: http://transcoder.net/content/output.mpd'
        },
        'hls_live': {
          title: 'HLS Live',
          placeholder: 'Example: http://transcoder.net/content/playlist.m3u8'
        },
        'shoutcast': {
          title: 'Shoutcast',
          placeholder: 'Example: http://transcoder.net/content/shoutcast-playlist.pls'
        },
        'youtube': {
          title: 'Youtube',
          placeholder: 'Example: https://www.youtube.com/user/ChannelName'
        },
        'dvb': {
          title: 'DVB',
          placeholder: 'Example: dvb:///name:freq:symbol_rate:.ts'
        }
      };

      service.getStreamTypeAttrs = function (type) {

        return service._STREAM_TYPES_ATTRS[type] || {
          title: type,
          placeholder: 'Unknown format'
        };
      };

      service.getOperator = function () {
        var deferred = $q.defer();

        lh.common.request.get('collection/operator/query')
          .then(function (response) {
            deferred.resolve(response.collection[0] || {});
          }, function (reason) {
            reason.url = 'collection/operator/query';
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.LocalizationManager = function (asset, scope) {

        var inner = $templateCache.get('asset-localization.html');
        inner = $compile(inner)(scope);

        ModalWindowService.Open({
          content: inner,
          isFixed: true,
          keyboard: true,
          size: {
            s: 12,
            l: 10
          },
          actions: [
            {
              title: 'Close',
              color: 'red'
            }
          ]
        });


      };

      service.Rental = {
        GetValues: function (asset) {
          if (asset._PrivateData && asset._PrivateData.isNew) {

            return {
              license_start: moment.utc().add(-1, 'day'),
              license_finish: moment.utc().add(1, 'year'),
              rotation_start: moment.utc().add(-1, 'day'),
              rotation_finish: moment.utc().add(1, 'year')
            }
          } else {

            return {
              license_start: asset.license_start ? (moment.isMoment(asset.license_start) ? asset.license_start : (moment.utc(asset.license_start * 1000))) : moment.utc(),
              license_finish: asset.license_finish ? (moment.isMoment(asset.license_finish) ? asset.license_finish : (moment.utc(asset.license_finish * 1000))) : moment.utc(),
              rotation_start: asset.rotation_start ? (moment.isMoment(asset.rotation_start) ? asset.rotation_start : (moment.utc(asset.rotation_start * 1000))) : moment.utc(),
              rotation_finish: asset.rotation_finish ? (moment.isMoment(asset.rotation_finish) ? asset.rotation_finish : (moment.utc(asset.rotation_finish * 1000))) : moment.utc()
            }
          }
        },
        Check: function (asset) {
          if (asset.rotation_finish > moment.utc().format('X')
            && asset.rotation_start <= moment.utc().format('X')) {
            return {
              inProgress: true,
              text: 'In Progress'
            };
          }

          if (asset.rotation_finish < moment.utc().format('X')) {
            return {
              inProgress: false,
              text: '<b>Rotation</b> window is expired'
            };
          }

          if (asset.rotation_start >= moment.utc().format('X')) {
            return {
              inProgress: false,
              text: '<b>Rotation</b> window is not started'
            };
          }

          return {
            inProgress: false,
            text: 'Check <b>Rotation</b> and <b>License</b> window'
          };
        }
      };

      service.Countries = {
        DeleteCountry: function (id) {
          var deferred = $q.defer();

          var data = {
            country_id: id
          };

          lh.common.request.post('metadata/mgmt/country/remove', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/country/remove';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        UpdateCountry: function (id, title) {
          var deferred = $q.defer();

          var data = {
            country_id: id,
            metadata: JSON.stringify({"_": {"title": title}})
          };

          lh.common.request.post('metadata/mgmt/country/update', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/country/update';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        CreateCountry: function (title, ext_id) {
          var deferred = $q.defer();

          var data = {
            ext_id: ext_id ? ext_id : 'local:' + translit(title),
            metadata: JSON.stringify({"_": {"title": title}})
          };

          lh.common.request.post('metadata/mgmt/country/create', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/country/create';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        }
      };

      service.Providers = {
        DeleteProvider: function (id) {
          var deferred = $q.defer();
          var data = {
            provider_id: id
          };
          lh.common.request.post('asset/mgmt/provider/remove', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'asset/mgmt/provider/remove';
              reason.data = data;
              deferred.reject(reason);
            });
          return deferred.promise;
        },
        UpdateProvider: function (id, title) {
          var deferred = $q.defer();
          var data = {
            provider_id: id,
            title: title
          };
          lh.common.request.post('asset/mgmt/provider/update', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'asset/mgmt/provider/update';
              reason.data = data;
              deferred.reject(reason);
            });
            return deferred.promise;
          },
        CreateProvider: function (title, ext_id) {
          var deferred = $q.defer();
          var data = {
            ext_id: ext_id ? translit(ext_id) : translit(title),
            title: title
          };
          lh.common.request.post('asset/mgmt/provider/create', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'asset/mgmt/provider/create';
              reason.data = data;
              deferred.reject(reason);
            });
            return deferred.promise;
        }
      };

      service.Studios = {
        DeleteStudio: function (id) {
          var deferred = $q.defer();

          var data = {
            studio_id: id
          };

          lh.common.request.post('metadata/mgmt/studio/remove', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/studio/remove';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        UpdateStudio: function (id, title) {
          var deferred = $q.defer();

          var data = {
            studio_id: id,
            metadata: JSON.stringify({"_": {"title": title}})
          };

          lh.common.request.post('metadata/mgmt/studio/update', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/studio/update';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        CreateStudio: function (title, ext_id) {
          var deferred = $q.defer();

          var data = {
            ext_id: ext_id ? ext_id : 'local:' + translit(title),
            metadata: JSON.stringify({"_": {"title": title}})
          };

          lh.common.request.post('metadata/mgmt/studio/create', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/studio/create';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        }
      };

      service.Genres = {
        DeleteGenre: function (id) {
          var deferred = $q.defer();

          var data = {
            genre_id: id
          };

          lh.common.request.post('metadata/mgmt/genre/remove', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/genre/remove';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        UpdateGenre: function (id, title, order) {
          var deferred = $q.defer();

          var data = {
            genre_id: id,
            metadata: JSON.stringify({"_": {"title": title}})
          };

          if (_.isNumber(order)) {
            data.order = order;
          }

          lh.common.request.post('metadata/mgmt/genre/update', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/genre/update';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        CreateGenre: function (title, ext_id) {
          var deferred = $q.defer();

          var data = {
            ext_id: ext_id ? ext_id : 'local:' + translit(title),
            metadata: JSON.stringify({"_": {"title": title}})
          };

          lh.common.request.post('metadata/mgmt/genre/create', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/genre/create';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        Update: function (oldGenres, newGenres, assetId) {
          var deferred = $q.defer();

          var all = {};

          var diffToRemove = _.filter(oldGenres, function (obj) {
            return obj && !_.find(newGenres, {id: obj.id});
          });
          var diffToAdd = _.filter(newGenres, function (obj) {
            return obj && !_.find(oldGenres, {id: obj.id});
          });

          if (diffToRemove.length) {
            all.remove = AssetService.RemoveGenres.bind(this, diffToRemove, assetId);
          }

          if (diffToAdd.length) {
            all.add = AssetService.AddGenres.bind(this, diffToAdd, assetId);
          }

          $q.seqAll(all)
            .then(function (responses) {
              deferred.resolve(responses);
            })
            .catch(function (reasons) {
              deferred.reject(reasons);
            });

          return deferred.promise;
        }
      };

      service.Categories = {
        DeleteCategory: function (id) {
          var deferred = $q.defer();

          var data = {
            category_id: id
          };

          lh.common.request.post('metadata/mgmt/category/remove', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/category/remove';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        UpdateCategory: function (id, title, order) {
          var deferred = $q.defer();

          var data = {
            category_id: id,
            metadata: JSON.stringify({"_": {"title": title}})
          };

          if (_.isNumber(order)) {
            data.order = order;
          }

          lh.common.request.post('metadata/mgmt/category/update', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/category/update';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        CreateCategory: function (title, ext_id, order) {
          var deferred = $q.defer();

          var data = {
            ext_id: ext_id ? ext_id : 'local:' + translit(title),
            metadata: JSON.stringify({"_": {"title": title}})
          };

          if (_.isNumber(order)) {
            data.order = order;
          }

          lh.common.request.post('metadata/mgmt/category/create', data)
            .then(function (response) {
              deferred.resolve(response);
            }, function (reason) {
              reason.url = 'metadata/mgmt/category/create';
              reason.data = data;
              deferred.reject(reason);
            });

          return deferred.promise;
        },

        Update: function (oldCategories, newCategories, assetId) {
          var deferred = $q.defer();

          var all = {};

          var diffToRemove = _.filter(oldCategories, function (obj) {
            return obj && !_.find(newCategories, {id: obj.id});
          });
          var diffToAdd = _.filter(newCategories, function (obj) {
            return obj && !_.find(oldCategories, {id: obj.id});
          });

          if (diffToRemove.length) {
            all.remove = AssetService.RemoveCategory.bind(this, diffToRemove, assetId);
          }

          if (diffToAdd.length) {
            all.add = AssetService.AddCategory.bind(this, diffToAdd, assetId);
          }

          $q.seqAll(all)
            .then(function (responses) {
              deferred.resolve(responses);
            })
            .catch(function (reasons) {
              deferred.reject(reasons);
            });

          return deferred.promise;
        }
      };

      service.Persons = {
        _personRoles: [
          {
            title: 'Operator',
            id: 'operator'
          },
          {
            title: 'Assembly',
            id: 'assembly'
          },
          {
            title: 'Actor',
            id: 'actor'
          },
          {
            title: 'Director',
            id: 'director'
          },
          {
            title: 'Scenario',
            id: 'scenario'
          },
          {
            title: 'Composer',
            id: 'composer'
          },
          {
            title: 'Presenter',
            id: 'presenter'
          },
          {
            title: 'Music Director',
            id: 'music_director'
          },
          {
            title: 'Playback Singers',
            id: 'playback_singers'
          }
        ],
        Prepare: function (persons, isSearch, list) {
          persons = persons.map(function (person, index) {
            person.index = index;
            if (isSearch) {
              person.inCollection = this.FindInCollection(list, person);
            } else {
              person.inCollection = true;
            }
            return person;
          }.bind(this));

          var roles = {};

          _.forEach(this._personRoles, function (role) {
            roles[role.id] = _.filter(persons, function (person) {
              return person.role === role.id;
            });
          });

          return roles;
        },

        FindInCollection: function (list, person) {
          return _.find(list, {id: person.id});
        },

        Process: function (asset, person, action) {
          if (action) {
            this.Add(asset, person, person.role);
          } else {
            this.Remove(asset, person, person.role);
          }
        },

        Create: function (person, asset) {
          person.role = person.role.id;
          return AssetService.CreatePerson(person)
            .then(function (response) {
              this.Add(asset, response.person, response.person.role);
              return $q.when();
            }.bind(this))
            .catch(function (reason) {
              $rootScope.debugInfo(reason);
              return $q.when();
            });
        },

        Add: function (asset, person, role) {
          asset._PrivateData.roles[role].unshift(person);
          asset._PrivateData.personsNew.push(person);
          person.inCollection = true;
        },

        Remove: function (asset, person, role) {

          var index = _.findIndex(asset._PrivateData.personsNew, function (pr) {
            return pr.id == person.id;
          });

          var indexInRoles = _.findIndex(asset._PrivateData.roles[role], function (pr) {
            return pr.id == person.id;
          });

          asset._PrivateData.personsNew.splice(index, 1);
          asset._PrivateData.roles[role].splice(indexInRoles, 1);
          person.inCollection = false;
        },

        PersonsManager: function (asset, personsToCompare, scope) {

          var deferred = $q.defer();

          var personSearchInnerScope = scope.$new(true);

          personSearchInnerScope.loading = false;

          personSearchInnerScope.rolesSearch = {};

          personSearchInnerScope.rolesSearch.list = [];
          personSearchInnerScope.rolesSearch.value = '';

          personSearchInnerScope.errors = {};

          personSearchInnerScope.tmpPerson = {};

          var unwatch = personSearchInnerScope.$watch('rolesSearch.value', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              var split = newValue.trim().split(' ');

              if (split.length === 1) {
                personSearchInnerScope.tmpPerson.first_name = split[0];
                personSearchInnerScope.tmpPerson.second_name = '';
                personSearchInnerScope.tmpPerson.middle_name = '';
              }

              if (split.length === 2) {
                personSearchInnerScope.tmpPerson.first_name = split[0];
                personSearchInnerScope.tmpPerson.second_name = split[1];
                personSearchInnerScope.tmpPerson.middle_name = '';
              }

              if (split.length === 3) {
                personSearchInnerScope.tmpPerson.first_name = split[0];
                personSearchInnerScope.tmpPerson.second_name = split[2];
                personSearchInnerScope.tmpPerson.middle_name = split[1];
              }
            }

            if (newValue && newValue !== oldValue) {
              if (searchTimeout) $timeout.cancel(searchTimeout);
              searchTimeout = $timeout(function () {
                personSearchInnerScope.loading = true;
                AssetService.SearchPerson(newValue)
                  .then(function (collection) {
                    personSearchInnerScope.loading = false;

                    personSearchInnerScope.list = collection;
                    personSearchInnerScope.roles = service.Persons.Prepare(personSearchInnerScope.list, true, personsToCompare);
                  })
                  .catch(function (reason) {
                    personSearchInnerScope.loading = false;

                    $rootScope.debugInfo(reason);
                  });
              }, 650);
            } else {
              personSearchInnerScope.list = [];
              personSearchInnerScope.roles = [];
            }
          });

          personSearchInnerScope.processPerson = scope.processPerson;
          personSearchInnerScope.availablePersonRoles = this._personRoles.map(function (role) {
            return {
              title: role.title,
              id: role.id
            }
          });
          personSearchInnerScope.originAsset = asset;

          personSearchInnerScope.validate = function (person) {
            personSearchInnerScope.errors = {};

            if (!person.first_name) personSearchInnerScope.errors.first_name = true;
            if (!person.second_name) personSearchInnerScope.errors.second_name = true;
            if (!person.role) personSearchInnerScope.errors.role = true;

            return personSearchInnerScope.errors;
          };

          personSearchInnerScope.createPerson = function (person) {
            if (!_.isEmpty(personSearchInnerScope.validate(person))) return;

            this.Create(person, personSearchInnerScope.originAsset)
              .then(function () {
                personSearchInnerScope.isNewPerson = false;
                personSearchInnerScope.rolesSearch.value = '';
                personSearchInnerScope.tmpPerson = {};
                inner.find('input#person_search').focus();
              });
          }.bind(this);

          personSearchInnerScope.scrollbarHeight = 0;

          var inner = $templateCache.get('add-cast-crew.html');
          var searchTimeout;

          inner = $compile(inner)(personSearchInnerScope);

          ModalWindowService.Open({
            content: inner,
            isFixed: true,
            keyboard: true,
            actions: [
              {
                title: 'DONE',
                color: 'green',
                fn: function () {
                  unwatch();
                  personSearchInnerScope.$destroy();
                  deferred.resolve();
                }
              }
            ],
            size: {
              s: 10,
              l: 6
            },
            onInit: function () {
              $timeout(function () {
                inner.find('input#person_search').focus();
              }, 350);
            }
          });

          return deferred.promise;
        },

        Update: function (oldPersons, newPersons, assetId) {
          var deferred = $q.defer();

          var all = {};

          var diffToRemove = _.filter(oldPersons, function (obj) {
            return obj && !_.find(newPersons, {id: obj.id});
          });
          var diffToAdd = _.filter(newPersons, function (obj) {
            return obj && !_.find(oldPersons, {id: obj.id});
          });

          if (diffToRemove.length) {
            all.remove = AssetService.RemovePerson.bind(this, diffToRemove, assetId);
          }

          if (diffToAdd.length) {
            all.add = AssetService.AddPerson.bind(this, diffToAdd, assetId);
          }

          $q.seqAll(all)
            .then(function (responses) {
              deferred.resolve(responses);
            })
            .catch(function (reasons) {
              deferred.reject(reasons);
            });

          return deferred.promise;
        }
      };

      service.Platforms = {
        GetAvailablePlatforms: function (asset, platforms) {
          if (asset._PrivateData.isNew) {
            return (platforms || []).map(function (platform) {
              if (!platform.title) platform.title = service.GetPlatformName(platform);

              platform.enabled = true;
              return platform;
            });
          } else {
            return (platforms || []).map(function (platform) {
              if (!platform.title) platform.title = service.GetPlatformName(platform);

              platform.enabled = asset.platform_id && asset.platform_id.indexOf(platform.id) !== -1;
              return platform;
            });
          }
        },

        Update: function (oldPlatforms, newPlatforms, assetId) {
          var deferred = $q.defer();

          var all = {};

          var diffToRemove = _.filter(newPlatforms, function (obj) {
            return !obj.enabled;
          });

          var diffToAdd = _.filter(newPlatforms, function (obj) {
            return obj.enabled;
          });

          if (diffToRemove.length) {
            all.remove = AssetService.RemovePlatforms.bind(this, diffToRemove, assetId);
          }

          if (diffToAdd.length) {
            all.add = AssetService.AddPlatforms.bind(this, diffToAdd, assetId);
          }

          $q.seqAll(all)
            .then(function (responses) {
              deferred.resolve(responses);
            })
            .catch(function (reasons) {
              deferred.reject(reasons);
            });

          return deferred.promise;
        }
      };

      service.Rating = {
        _types: {'imdb': 'IMDb', 'metascore': 'Metascore', 'mpaa': 'MPAA'},

        mpaaValues: [
          {
            rating: 0,
            title: 'General Audiences [G]',
            id: 'G'
          },
          {
            rating: 1,
            title: 'Parental Guidance Suggested [PG]',
            id: 'PG'
          },
          {
            rating: 2,
            title: 'Parents Strongly Cautioned [PG-13]',
            id: 'PG-13'
          },
          {
            rating: 3,
            title: 'Restricted [R]',
            id: 'R'
          },
          {
            rating: 4,
            title: 'Adults Only [NC-17]',
            id: 'NC-17'
          }
        ],

        GetValue: function (rating) {
          if (rating.type === 'mpaa') {
            return {
              label: this._types[rating.type],
              value: _.find(this.mpaaValues, {rating: rating.avg_value}),
              votes_count: 0,
              type: rating.type
            }
          } else {
            return {
              label: this._types[rating.type],
              value: rating.avg_value,
              votes_count: rating.votes_count,
              type: rating.type
            }
          }
        },

        IsRating: function (asset, rating_extid) {
          return !!_.find(asset, {type: rating_extid});
        },

        Update: function (oldRatings, newRatings, assetId) {

          var deferred = $q.defer();

          newRatings = newRatings.filter(function (rating) {

            return !!rating.value || rating.value === 0;
          });

          AssetService.AddRating(newRatings, assetId)
            .then(function (responses) {
              deferred.resolve(responses);
            })
            .catch(function (reasons) {
              deferred.reject(reasons);
            });

          return deferred.promise;
        }
      };

      service.Quality = {
        SetValue: function (asset, value) {
          asset._PrivateData.qualityFormat = value;
        }
      };

      service.Catchup = {
        GetValue: function (resource) {
          return parseInt((resource.depth | 0), 10);
        },

        ChangeValue: function (asset, scope) {
          if (!asset._PrivateData.catchupNew.source) asset._PrivateData.catchupNew.source = asset._PrivateData.streamsResources['hls_live'].source || '';

          var inner = $templateCache.get('catchup-options.html');
          inner = $compile(inner)(scope);

          ModalWindowService.Open({
            content: inner,
            keyboard: true,
            actions: [
              {
                title: 'Done',
                color: 'green',
                fn: function () {
                  if (!asset._PrivateData.catchupNew.source || !asset._PrivateData.catchupNew.depth) {
                    $timeout(function () {
                      asset._PrivateData.catchupNew.isEnabled = false;
                    });
                  } else {
                    $timeout(function () {
                      asset._PrivateData.catchupNew.isEnabled = true;
                    });
                  }
                }
              },
              {
                title: 'Cancel',
                color: 'red',
                fn: function () {
                }
              }
            ],
            size: {
              s: 6,
              l: 4
            },
            onComplete: function (result) {
              if (!result) {
                $timeout(function () {
                  asset._PrivateData.catchupNew.isEnabled = false
                });
              }
            }
          });
        }
      };

      service.Catchup2 = {
        ChangeValue: function (asset, scope) {
          var inner = $templateCache.get('add-catchup.html');
          inner = $compile(inner)(scope);

          ModalWindowService.Open({
            content: inner,
            keyboard: true,
            actions: [
              {
                title: 'Done',
                color: 'green',
                fn: function () {
                 for (var i = 0; i < scope.channel.streamResources.length; i++) {
                    var r = scope.channel.streamResources[i];
                    if (r.category.toLowerCase() === 'catchup') {
                      scope.channel.streamResources.splice(i, 1);
                    }
                  }
                  scope.channel.streamResources.push({
                    type: 'dvr2',
                    category: 'catchup',
                    group: 'catchup',
                    state: 'preparing',
                    URL: scope.channel.catchup.source,
                    depth: parseInt(scope.channel.catchup.depth) || 0,
                    preparer: 'passthrough',
                    deployer: 'origin',
                    private: true,
                    tags: ''
                  });
                  $rootScope.$digest();
                }
              },
              {
                title: 'Cancel',
                color: 'red',
                fn: function () {
                }
              }
            ],
            size: {
              s: 6,
              l: 4
            },
            onComplete: function (result) {
            }
          });
        }
      };

      service.Npvr = {
        ChangeValue: function (asset, scope) {
          if (!asset._PrivateData.npvrNew.isEnabled) {
            asset._PrivateData.npvrNew.isEnabled = false;
          } else {
            if (!asset._PrivateData.npvrNew.source) asset._PrivateData.npvrNew.source = asset._PrivateData.streamsResources['hls_live'].source || '';

            var inner = $templateCache.get('npvr-options.html');
            inner = $compile(inner)(scope);

            ModalWindowService.Open({
              content: inner,
              keyboard: true,
              actions: [
                {
                  title: 'Done',
                  color: 'green',
                  fn: function () {
                    if (!asset._PrivateData.npvrNew.source) {
                      $timeout(function () {
                        asset._PrivateData.npvrNew.isEnabled = false
                      });
                    }
                  }
                },
                {
                  title: 'Cancel',
                  color: 'red',
                  fn: function () {
                    $timeout(function () {
                      asset._PrivateData.npvrNew.isEnabled = false
                    });
                  }
                }
              ],
              size: {
                s: 6,
                l: 4
              },
              onComplete: function (result) {
                if (!result) {
                  $timeout(function () {
                    asset._PrivateData.npvrNew.isEnabled = false
                  });
                }
              }
            });
          }
        }
      };

      service.ImportMetadata = function (meta) {
        var deferred = $q.defer();

        var data = {
          url: 'https://storage-sc-ott3.s3.amazonaws.com/' + meta + '.xml'
        };

        var url = 'asset/import/perform';

        lh.common.request.post(url, data)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      };

      service.ValidateMetadata = {};

      service.ValidateMetadata.Vod = function (asset) {
        var validateErrors = {};

        if (!asset.title) {
          validateErrors.title = true;
        }

        for (var i = 0; i < asset._PrivateData.ratingsNew.length; i++) {
          if (asset._PrivateData.ratingsNew[i].type !== 'mpaa') {
            if (asset._PrivateData.ratingsNew[i].value && !ValidatorService.Numerical(asset._PrivateData.ratingsNew[i].value)) {
              if (!validateErrors.ratings) validateErrors.ratings = [];
              if (!validateErrors.ratings[i]) validateErrors.ratings[i] = {};
              validateErrors.ratings[i].errorValue = true;
            }
            if (asset._PrivateData.ratingsNew[i].votes_count && !ValidatorService.Numerical(asset._PrivateData.ratingsNew[i].votes_count)) {
              if (!validateErrors.ratings) validateErrors.ratings = [];
              if (!validateErrors.ratings[i]) validateErrors.ratings[i] = {};
              validateErrors.ratings[i].errorCount = true;
            }
          }
        }

        if (!ValidatorService.Numerical(asset.year)) {
          validateErrors.year = true;
        }

        if (!asset.description) {
          validateErrors.description = true;
        }

        //if (!asset._PrivateData.countriesNew) {
        //  validateErrors.country = true;
        //}

        // if (!asset._PrivateData.platformsNew.filter(function (platform) {
        //     return platform.enabled;
        //   }).length) {
        //   validateErrors.platforms = true;
        // }

        asset._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.ValidateMetadata.Live = function (asset) {
        var validateErrors = {};

        if (!asset.title) {
          validateErrors.title = true;
        }

        if (!ValidatorService.Numerical(asset.lcn || asset.er_lcn)) {
          validateErrors.lcn = true;
          validateErrors.lcnText = 'Should be a number';
        }

        //if (_.isEmpty(asset._PrivateData.epgChannelIdNew)) {
        //  validateErrors.epg_channel_id = true;
        //}

        // if (!asset._PrivateData.platformsNew.filter(function (platform) {
        //     return platform.enabled;
        //   }).length) {
        //   validateErrors.platforms = true;
        // }

        asset._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.ValidateMetadata.VirtualLive = function (asset) {
        var validateErrors = {};

        if (!asset.title) {
          validateErrors.title = true;
        }

        if (!ValidatorService.Numerical(asset.lcn || asset.er_lcn)) {
          validateErrors.lcn = true;
          validateErrors.lcnText = 'Should be a number';
        }

        //if (_.isEmpty(asset._PrivateData.epgChannelIdNew)) {
        //  validateErrors.epg_channel_id = true;
        //}

        // if (!asset._PrivateData.platformsNew.filter(function (platform) {
        //     return platform.enabled;
        //   }).length) {
        //   validateErrors.platforms = true;
        // }

        asset._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.ValidateMetadata.TVSeries = function (asset) {
        var validateErrors = {};

        if (!asset.title) {
          validateErrors.title = true;
        }

        if (!asset.description) {
          validateErrors.description = true;
        }

        for (var i = 0; i < asset._PrivateData.ratingsNew.length; i++) {
          if (asset._PrivateData.ratingsNew[i].type !== 'mpaa') {
            if (asset._PrivateData.ratingsNew[i].value && !ValidatorService.Numerical(asset._PrivateData.ratingsNew[i].value)) {
              if (!validateErrors.ratings) validateErrors.ratings = [];
              if (!validateErrors.ratings[i]) validateErrors.ratings[i] = {};
              validateErrors.ratings[i].errorValue = true;
            }
            if (asset._PrivateData.ratingsNew[i].votes_count && !ValidatorService.Numerical(asset._PrivateData.ratingsNew[i].votes_count)) {
              if (!validateErrors.ratings) validateErrors.ratings = [];
              if (!validateErrors.ratings[i]) validateErrors.ratings[i] = {};
              validateErrors.ratings[i].errorCount = true;
            }
          }
        }

        //if (!ValidatorService.Numerical(asset._PrivateData.durationNew)) {
        //  validateErrors.duration = true;
        //}

        if (!ValidatorService.Numerical(asset.year)) {
          validateErrors.year = true;
        }

        //if (!asset._PrivateData.countriesNew) {
        //  validateErrors.country = true;
        //}

        // if (!asset._PrivateData.platformsNew.filter(function (platform) {
        //     return platform.enabled;
        //   }).length) {
        //   validateErrors.platforms = true;
        // }

        asset._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.ValidateMetadata.TVEpisode = function (asset) {
        var validateErrors = {};

        if (!asset.title) {
          validateErrors.title = true;
        }

        //if (!ValidatorService.Numerical(asset._PrivateData.durationNew)) {
        //  validateErrors.duration = true;
        //}

        for (var i = 0; i < asset._PrivateData.ratingsNew.length; i++) {
          if (asset._PrivateData.ratingsNew[i].type !== 'mpaa') {
            if (asset._PrivateData.ratingsNew[i].value && !ValidatorService.Numerical(asset._PrivateData.ratingsNew[i].value)) {
              if (!validateErrors.ratings) validateErrors.ratings = [];
              if (!validateErrors.ratings[i]) validateErrors.ratings[i] = {};
              validateErrors.ratings[i].errorValue = true;
            }
            if (asset._PrivateData.ratingsNew[i].votes_count && !ValidatorService.Numerical(asset._PrivateData.ratingsNew[i].votes_count)) {
              if (!validateErrors.ratings) validateErrors.ratings = [];
              if (!validateErrors.ratings[i]) validateErrors.ratings[i] = {};
              validateErrors.ratings[i].errorCount = true;
            }
          }
        }

        if (!asset.description) {
          validateErrors.description = true;
        }

        if (!asset._PrivateData.seasonIndexNew) {
          validateErrors.season_index = true;
        }

        if (!ValidatorService.Numerical(asset._PrivateData.episodeIndexNew)) {
          validateErrors.episode_index = true;
        }

        asset._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.ValidateMetadata.Offer = function (offer) {
        var validateErrors = {};

        if (!offer._PrivateData.name) {
          validateErrors.name = true;
        }

        if (!offer._PrivateData.type && !offer._PrivateData.isFree) {
          validateErrors.type = true;
        }

        if (!_.isFinite(parseFloat(offer._PrivateData.billing_params_price)) && parseFloat(offer._PrivateData.billing_params_price) > 0 && !offer._PrivateData.isFree) {
          validateErrors.price = true;
        }

        if (!offer._PrivateData.billing_params_currency && !offer._PrivateData.isFree) {
          validateErrors.currency = true;
        }

        if (offer._PrivateData.type !== 'transactional-own' && !offer._PrivateData.isFree) {
          if (!ValidatorService.Numerical(offer._PrivateData.right_params_duration) || offer._PrivateData.right_params_duration == 0) {
            validateErrors.duration = true;
          }

          if (!offer._PrivateData.right_params_duration_unit) {
            validateErrors.unit = true;
          }
        }

        offer._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.ValidateMetadata.Plan = function (plan) {
        var validateErrors = {};

        if (!plan._PrivateData.name) {
          validateErrors.name = true;
        }

        if (!plan._PrivateData.type) {
          validateErrors.type = true;
        }

        if (!_.isFinite(parseFloat(plan._PrivateData.billing_params_price)) && !(parseFloat(plan._PrivateData.billing_params_price) > 0) && !plan._PrivateData.isFree) {
          validateErrors.price = true;
        }

        if (!plan._PrivateData.billing_params_currency && !plan._PrivateData.isFree) {
          validateErrors.currency = true;
        }

        if (!ValidatorService.Numerical(plan._PrivateData.right_params_duration) || plan._PrivateData.right_params_duration == 0) {
          validateErrors.duration = true;
        }

        if (!plan._PrivateData.right_params_duration_unit) {
          validateErrors.unit = true;
        }

        if (plan._PrivateData.isTrialAvailable && !plan._PrivateData.right_params_trial_duration) {
          validateErrors.trial_duration = true;
        }

        if (plan._PrivateData.isTrialAvailable && !plan._PrivateData.right_params_trial_duration_unit) {
          validateErrors.trial_unit = true;
        }

        plan._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.ValidateMetadata.Package = function (pkg) {
        var validateErrors = {};

        if (!pkg._PrivateData.title) {
          validateErrors.title = true;
        }

        return pkg._PrivateData.validateErrors = validateErrors, validateErrors;
      };

      service.ValidateMetadata.EpgImport = function (task) {
        var validateErrors = {};

        if (_.isEmpty(task._PrivateData.source)) {
          validateErrors.source = true;
        }

        task._PrivateData.validateErrors = validateErrors;

        return validateErrors;
      };

      service.MediaManager2 = function (asset, scope, type, oldResource, cdnTags) {
        var deferred = $q.defer();

        var MediaInnerScope = scope.$new(true);

        MediaInnerScope.resourceCategory = type;
        MediaInnerScope.error = '';
        MediaInnerScope.isLive = asset.type === 'channel';

        MediaInnerScope.templates = [{
          id: 'hls',
          title: 'HLS - H264 HD / AAC',
          type: 'hls'
        }];

        var tags = [];
        if (cdnTags) {
          for (var i = 0; i < cdnTags.length; i += 1) {
            tags.push({
              id: cdnTags[i],
              title: cdnTags[i],
            })
          }
        }

        // Init
        MediaInnerScope.tmpMedia = {
          type: 'media_stream', // media_raw_file, media_raw_external, media_stream, youtube_stream, shoutcast_stream
          template: MediaInnerScope.templates[0],
          tags: tags,
          url: '',
          deploymentStrategy: MediaInnerScope.isLive ? 'origin' : 'origin_proxy',
          private: '1',
          tag: {},
          drm: false,
          edit: false,
          group: 'stream',
        };

        if (oldResource) {
          MediaInnerScope.tmpMedia.edit = true;
          MediaInnerScope.tmpMedia.type = oldResource.type.toLowerCase() === 'shoutcast' ? 'shoutcast_stream' : 'media_stream';
          if (oldResource.type.toLowerCase().endsWith('protected')) {
            MediaInnerScope.tmpMedia.drm = true;
          }
          MediaInnerScope.tmpMedia.url = oldResource.URL.replace('http+proxy://', 'http://');
          if (oldResource.category === 'trailer') {
            type = 'trailer';
            MediaInnerScope.resourceCategory = 'trailer';
          }
          MediaInnerScope.tmpMedia.private = oldResource.private ? '1' : '0';
          if (oldResource.deployerArgs && oldResource.deployerArgs.cdn_tag) {
            MediaInnerScope.tmpMedia.tag = {
              id: oldResource.deployerArgs.cdn_tag,
              title: oldResource.deployerArgs.cdn_tag,
            }
          }
          if (oldResource.tags) {
            MediaInnerScope.tmpMedia.tag = {
              id: oldResource.tags,
              title: oldResource.tags,
            };
          }
          if (oldResource.deployer === 'passthrough') {
            MediaInnerScope.tmpMedia.deploymentStrategy = 'passthrough';
          }
          MediaInnerScope.tmpMedia.group = oldResource.group;
        }

        MediaInnerScope.selectType = function (type) {
          MediaInnerScope.error = '';
          //MediaInnerScope.tmpMedia.url = '';
          MediaInnerScope.tmpMedia.type = type;
          MediaInnerScope.tmpMedia.deploymentStrategy = type == 'media_stream' && !MediaInnerScope.isLive ? 'origin_proxy' : 'origin';
        };

        MediaInnerScope.close = function () {
          if (MediaInnerScope.loading) return;
          ModalWindowService.Close(MediaInnerScope.window, false);
        };

        var inner = $templateCache.get('add-video.html');
        inner = $compile(inner)(MediaInnerScope);

        MediaInnerScope.processMedia = function () {
          if (MediaInnerScope.tmpMedia.url) {
            var resource = {
              type: '', // VOD: dash, hls, youtube+video  LIVE: dash-live, dvb, hls-live, youtube+channel
              category: '', // '' or trailer
              deployer: '', // passthrough, origin
              private: true,
              group: MediaInnerScope.tmpMedia.group,
              URL: '',
              preparer: '', // passthrough, noisypeak,
              state: 'preparing',
              tags: '',
              depth: 0,
            };

            if (MediaInnerScope.isLive) {
              resource.type = 'hls-live';
              resource.category = '';
              resource.deployer = MediaInnerScope.tmpMedia.deploymentStrategy;
              resource.private = MediaInnerScope.tmpMedia.deploymentStrategy === 'origin' && MediaInnerScope.tmpMedia.private === '1';
              resource.URL = MediaInnerScope.tmpMedia.url;
              resource.preparer = 'passthrough';
              resource.tags = MediaInnerScope.tmpMedia.tag.title || '';

              if (MediaInnerScope.tmpMedia.type === 'youtube_stream') {
                resource.type = 'youtube+channel';
              }
              if (MediaInnerScope.tmpMedia.type === 'shoutcast_stream') {
                resource.type = 'shoutcast';
                resource.deployer = 'passthrough';
              }
              if (MediaInnerScope.tmpMedia.type === 'media_stream') {
                var ext = MediaInnerScope.tmpMedia.url.split('/').pop().split('.').pop();
                if (ext === 'mpd') {
                  resource.type = 'dash-live';

                } else if (ext === 'm3u8') {
                  resource.type = 'hls-live';

                } else if (ext === 'ts') {
                  resource.type = 'dvb';
                }
              }
            } else {
              resource.type = 'hls';
              resource.category = type === 'trailer' ? type : '';
              resource.deployer = MediaInnerScope.tmpMedia.deploymentStrategy === 'passthrough' ? 'passthrough' : 'origin';
              resource.private = MediaInnerScope.tmpMedia.deploymentStrategy !== 'passthrough' && MediaInnerScope.tmpMedia.private === '1';
              if (resource.category === 'trailer') resource.private = false;
              resource.preparer = 'passthrough';
              resource.URL = MediaInnerScope.tmpMedia.url;
              resource.tags = MediaInnerScope.tmpMedia.tag.title || '';

              if (MediaInnerScope.tmpMedia.type === 'media_raw_file' || MediaInnerScope.tmpMedia.type === 'media_raw_external') {
                resource.preparer = 'noisypeak';
              }
              if (MediaInnerScope.tmpMedia.type === 'youtube_stream') {
                resource.type = 'youtube+video';
              }
              if (MediaInnerScope.tmpMedia.type === 'media_stream') {
                var ext = MediaInnerScope.tmpMedia.url.split('/').pop().split('.').pop();
                if (ext === 'mpd') {
                  resource.type = 'dash';
                } else if (ext === 'm3u8') {
                  resource.type = 'hls';
                }
                if (MediaInnerScope.tmpMedia.deploymentStrategy === 'origin_proxy') {
                  resource.URL = resource.URL.replace('http://', 'http+proxy://');
                  resource.URL = resource.URL.replace('https://', 'http+proxy://');
                }
              }
            }

            if (MediaInnerScope.tmpMedia.drm) {
              resource.type += '-protected';
            }

            if (oldResource) {
              for (var i = 0; i < asset.streamResources.length; i++) {
                var r = asset.streamResources[i];
                if (oldResource.type.toUpperCase() === r.type.toUpperCase() && oldResource.category.toUpperCase() === r.category.toUpperCase()) {
                  asset.streamResources.splice(i, 1);
                  break;
                }
              }
            }
            for (var i = 0; i < asset.streamResources.length; i++) {
              var r = asset.streamResources[i];
              if (r.type.toUpperCase() === resource.type.toUpperCase() && r.category.toUpperCase() === resource.category.toUpperCase()) {
                asset.streamResources.splice(i, 1);
                break;
              }
            }
            asset.streamResources.push(angular.copy(resource));
          }
          $rootScope.$digest();
        };

        MediaInnerScope.window = ModalWindowService.Open({
          content: inner,
          clear: true,
          isFixed: true,
          keyboard: true,
          actions: [
            {
              title: MediaInnerScope.tmpMedia.edit ? 'Save' : 'Add',
              fn: MediaInnerScope.processMedia,
              check: function () {
                MediaInnerScope.error = '';
                if (MediaInnerScope.loading) return false;

                if (!MediaInnerScope.tmpMedia.url) {
                  MediaInnerScope.error = 'Source was not found. Try again.';
                }

                if (MediaInnerScope.tmpMedia.url) {
                  if (MediaInnerScope.tmpMedia.type === 'media_stream') {
                    var urlWithoutQuery = MediaInnerScope.tmpMedia.url.split('?')[0];
                    var ext = urlWithoutQuery.split('/').pop().split('.').pop();

                    if (['m3u8', 'ts', 'mpd'].indexOf(ext) === -1) {
                      MediaInnerScope.error = 'Unsupported stream format';
                    }
                  }

                  if (MediaInnerScope.tmpMedia.type === 'youtube_stream') {
                    if (MediaInnerScope.isLive) {
                      if (!ValidatorService.YoutubeChannel(MediaInnerScope.tmpMedia.url) && !ValidatorService.YoutubeUser(MediaInnerScope.tmpMedia.url)) {
                        MediaInnerScope.error = 'Wrong Youtube channel or user https://www.youtube.com/channel/xxxxxxxx or https://www.youtube.com/user/xxxxxxxx';
                      }
                    } else {
                      if (!ValidatorService.YoutubeVideo(MediaInnerScope.tmpMedia.url)) {
                        MediaInnerScope.error = 'Wrong Youtube video https://www.youtube.com/watch?v=xxxxxxx';
                      }
                    }
                  }
                }
                return MediaInnerScope.error === '';
              }
            }
          ],
          size: {
            s: 10,
            l: 6
          }
        });

        inner.on('$destroy', function () {
          MediaInnerScope.$destroy();
        });

        return deferred.promise;
      };


        service.MediaManager = function (asset, scope, type) {
        var deferred = $q.defer();

        var MediaInnerScope = scope.$new(true);

        MediaInnerScope.errors = {};
        MediaInnerScope.success = {};
        MediaInnerScope.uploadInProgress = false;
        MediaInnerScope.isLive = asset.type === 'channel';

        MediaInnerScope.templates = [
          {
            id: 'hls',
            title: 'HLS - H264 HD / AAC',
            type: 'hls'
          }
        ];

        MediaInnerScope.tmpMedia = {
          template: MediaInnerScope.templates[0],
          type: 'media_stream',
          showAdvanced: false,
          deploymentStrategy: 'origin',
          overrideDeliveryMethod: false
        };

        MediaInnerScope.validate = function (person) {
          MediaInnerScope.errors = {};

          if (!person.first_name) MediaInnerScope.errors.first_name = true;
          if (!person.second_name) MediaInnerScope.errors.second_name = true;
          if (!person.role) MediaInnerScope.errors.role = true;

          return MediaInnerScope.errors;
        };

        MediaInnerScope.selectType = function (type) {
          MediaInnerScope.errors = {};
          MediaInnerScope.tmpMedia.source = '';
          MediaInnerScope.tmpMedia.type = type;
        };

        MediaInnerScope.toggleAdvanced = function () {
          MediaInnerScope.tmpMedia.showAdvanced = !MediaInnerScope.tmpMedia.showAdvanced;
        };

        MediaInnerScope.selectFile = function () {
         $timeout(function () {
            MediaInnerScope._fileInput_.trigger('click');
          });
        };

        MediaInnerScope.close = function () {
          if (MediaInnerScope.loading) return;

          ModalWindowService.Close(MediaInnerScope.window, false);
        };

        var inner = $templateCache.get('add-media.html');
        inner = $compile(inner)(MediaInnerScope);

        $timeout(function () {
          MediaInnerScope._fileInput_ = inner.find('input#media_file_input');
          MediaInnerScope._form_ = inner.find('form#media_form_input');
          //MediaInnerScope._dropArea_ = inner.find('img#drop_here');
          MediaInnerScope._progress_ = inner.find('#fileLoader');
          MediaInnerScope._bar_ = MediaInnerScope._progress_.find('.determinate');

          MediaInnerScope._fileInput_
            .on('change', function () {

              var files = this.files;

              if (!files.length) {
                $timeout(function () {
                  MediaInnerScope.errors.upload = 'Choose one file';
                });
                return;
              }

              MediaInnerScope.errors.upload = '';
              MediaInnerScope.success.upload = '';

              MediaInnerScope.tmpMedia.file = files[0];

              if (MediaInnerScope.tmpMedia.file.size > 104857600) {
                MediaInnerScope.errors.upload = 'File size exceed 100 MB. This file size is: ' + parseInt(MediaInnerScope.tmpMedia.file.size / 1024 / 1024, 10) + ' MB';
                MediaInnerScope._form_[0].reset();

                return;
              }

              MediaInnerScope.uploadInProgress = true;
              MediaInnerScope.success.upload = false;

              ImportService.UploadToCloud(MediaInnerScope.tmpMedia.file, MediaInnerScope._progress_)
                .then(function (response) {
                  MediaInnerScope._bar_.css({width: '0%'});
                  MediaInnerScope.tmpMedia.source = response.Location;
                  $timeout(function () {
                    MediaInnerScope.uploadInProgress = false;
                    MediaInnerScope.success.upload = 'Upload successfully done. You can save result';
                    MediaInnerScope.errors.upload = false;
                  });
                }, function (reason) {
                  $timeout(function () {
                    MediaInnerScope.errors.upload = reason.message || 'Error during upload';
                    MediaInnerScope._form_[0].reset();
                    MediaInnerScope.uploadInProgress = false;
                    MediaInnerScope._bar_.css({width: '0%'});
                  });

                  $rootScope.debugInfo(reason, 'silent');
                })
                .then(function () {
                  MediaInnerScope._fileInput_.innerHTML =  MediaInnerScope._fileInput_.innerHTML;
                });

              MediaInnerScope._form_[0].reset();
            });

/*          MediaInnerScope._dropArea_.bind("dragenter", dragEnter);
          MediaInnerScope._dropArea_.bind("dragleave", dragLeave);
          MediaInnerScope._dropArea_.bind("dragover", dragOver);
          MediaInnerScope._dropArea_.bind("drop", dragDrop);

          MediaInnerScope._dropArea_.on('$destroy', function () {
            MediaInnerScope._dropArea_.unbind("dragenter", dragEnter);
            MediaInnerScope._dropArea_.unbind("dragleave", dragLeave);
            MediaInnerScope._dropArea_.unbind("dragover", dragOver);
            MediaInnerScope._dropArea_.unbind("drop", dragDrop);
          });*/
        }, 200);

   /*     var dragEnter = function (evt) {
          if (evt.stopPropagation) evt.stopPropagation();
          if (evt.preventDefault) evt.preventDefault();
          $timeout(function () {
            MediaInnerScope.isOver = true;
          });
          $timeout(function () {
            MediaInnerScope.errors.upload = '';
          });
        };

        var dragLeave = function (evt) {
          if (evt.stopPropagation) evt.stopPropagation();
          if (evt.preventDefault) evt.preventDefault();
          $timeout(function () {
            MediaInnerScope.isOver = false;
          });
          $timeout(function () {
            MediaInnerScope.errors.upload = '';
          });
        };

        var dragOver = function (evt) {
          if (evt.stopPropagation) evt.stopPropagation();
          if (evt.preventDefault) evt.preventDefault();
          $timeout(function () {
            MediaInnerScope.errors.upload = '';
          });

          var ok = evt.originalEvent.dataTransfer
            && evt.originalEvent.dataTransfer.types
            && evt.originalEvent.dataTransfer.types.indexOf('Files') >= 0;

          if (!ok) {
            $timeout(function () {
              MediaInnerScope.errors.upload = 'Your browser does not support this feature. <br/> please use "Upload"';
            });
            return;
          }
        };

        var dragDrop = function (evt) {
          if (evt.stopPropagation) evt.stopPropagation();
          if (evt.preventDefault) evt.preventDefault();

          $timeout(function () {
            MediaInnerScope.errors.upload = '';
          });


          var ok = evt.originalEvent.dataTransfer
            && evt.originalEvent.dataTransfer.types
            && evt.originalEvent.dataTransfer.types.indexOf('Files') >= 0;

          if (!ok) {
            $timeout(function () {
              MediaInnerScope.errors.upload = 'Your browser does not support this feature. <br/> please use "Upload"';
            });
            return;
          }

          var files = evt.originalEvent.dataTransfer.files;

          if (!files.length) {
            $timeout(function () {
              MediaInnerScope.errors.upload = 'Choose one file';
            });
            return;
          }

          MediaInnerScope.tmpMedia.file = files[0];

          MediaInnerScope.uploadInProgress = true;
          MediaInnerScope.success.upload = false;
          ImportService.UploadToCloud(MediaInnerScope.tmpMedia.file, MediaInnerScope._progress_)
            .then(function (response) {
              MediaInnerScope._bar_.css({width: '0%'});
              MediaInnerScope.tmpMedia.source = response.Location;
              $timeout(function () {
                MediaInnerScope.uploadInProgress = false;
                MediaInnerScope.success.upload = 'Upload success. You can save result';
                MediaInnerScope.errors.upload = false;
              });
            }, function (reason) {
              MediaInnerScope._bar_.css({width: '0%'});
              $timeout(function () {
                MediaInnerScope.uploadInProgress = false;
                MediaInnerScope.errors.upload = 'Error during upload';
              });
              $rootScope.debugInfo(reason, 'silent');
            })
            .then(function () {
              MediaInnerScope._fileInput_.innerHTML =  MediaInnerScope._fileInput_.innerHTML;
            });
        };*/

        MediaInnerScope.processMedia = function () {

          if (MediaInnerScope.tmpMedia.source) {
            if (MediaInnerScope.tmpMedia.type === 'media_stream') {
              var ext = MediaInnerScope.tmpMedia.source.split('/').pop().split('.').pop();

              if (ext === 'mpd') {
                MediaInnerScope.tmpMedia.template.type = MediaInnerScope.isLive ? 'dash_live' : 'dash';
              } else if (ext === 'm3u8') {
                MediaInnerScope.tmpMedia.template.type = MediaInnerScope.isLive ? 'hls_live' : 'hls';
              } else if (ext === 'ts' && MediaInnerScope.isLive) {
                MediaInnerScope.tmpMedia.template.type = 'dvb';
              } else {
                MediaInnerScope.tmpMedia.template.type = MediaInnerScope.isLive ? 'hls_live' : 'hls';
              }
            }
            if (MediaInnerScope.tmpMedia.type === 'youtube_stream') {
              MediaInnerScope.tmpMedia.template.type = 'youtube';
            }
            if (MediaInnerScope.tmpMedia.type === 'shoutcast_stream') {
              MediaInnerScope.tmpMedia.template.type = 'shoutcast';
              MediaInnerScope.tmpMedia.template.deploymentStrategy = "passthrough";
              MediaInnerScope.tmpMedia.deploymentStrategy = "passthrough";
            }

            MediaInnerScope.tmpMedia = _.merge(MediaInnerScope.tmpMedia, service._STREAM_TYPES_ATTRS[MediaInnerScope.tmpMedia.template.type]);

            if (type === 'trailer') {
              asset._PrivateData.trailersResources[MediaInnerScope.tmpMedia.template.type] = MediaInnerScope.tmpMedia;
              asset._PrivateData.trailersResources[MediaInnerScope.tmpMedia.template.type].strategy = 'NEW';
            } else {
              asset._PrivateData.streamsResources[MediaInnerScope.tmpMedia.template.type] = MediaInnerScope.tmpMedia;
              asset._PrivateData.streamsResources[MediaInnerScope.tmpMedia.template.type].strategy = 'NEW';
            }
          }

          $rootScope.$digest();
        };

        MediaInnerScope.window = ModalWindowService.Open({
          content: inner,
          clear: true,
          isFixed: true,
          keyboard: true,
          actions: [
            {
              title: 'Add',
              fn: MediaInnerScope.processMedia,
              check: function () {
                MediaInnerScope.errors = {};

                if (MediaInnerScope.loading) return false;

                if (MediaInnerScope.uploadInProgress) {
                  MediaInnerScope.errors.upload = 'Wait until file upload finished';
                } else if (!MediaInnerScope.tmpMedia.source) {
                  MediaInnerScope.errors.source = 'Source was not found. Try again.';
                }

                if (MediaInnerScope.tmpMedia.source) {
                  if (MediaInnerScope.tmpMedia.type === 'media_stream') {
                    var urlWithoutQuery = MediaInnerScope.tmpMedia.source.split('?')[0];
                    var ext = urlWithoutQuery.split('/').pop().split('.').pop();

                    if (['m3u8', 'ts', 'mpd'].indexOf(ext) === -1) {
                      MediaInnerScope.errors.source = 'Unsupported stream format';
                    }
                  }

                  if (MediaInnerScope.tmpMedia.type === 'youtube_stream') {
                    if (MediaInnerScope.isLive) {

                      if (!ValidatorService.YoutubeChannel(MediaInnerScope.tmpMedia.source) && !ValidatorService.YoutubeUser(MediaInnerScope.tmpMedia.source)) {
                        MediaInnerScope.errors.source = 'Wrong Youtube channel or user: https://www.youtube.com/channel/xxxxxxxx or https://www.youtube.com/user/xxxxxxxx';
                      }
                    } else {

                      if (!ValidatorService.YoutubeVideo(MediaInnerScope.tmpMedia.source)) {
                        MediaInnerScope.errors.source = 'Wrong Youtube video: https://www.youtube.com/watch?v=xxxxxxx';
                      }
                    }
                  }
                }

                return !_.size(MediaInnerScope.errors);
              }
            }
          ],
          size: {
            s: 10,
            l: 6
          }
        });

        inner.on('$destroy', function () {
          MediaInnerScope.$destroy();
        });

        return deferred.promise;
      };

      service.languages = {
        list: [
          { id: "EN", title: "English" },
          { id: "DE", title: "German" },
          { id: "ES", title: "Spanish" },
          { id: "FR", title: "French" },
          { id: "IT", title: "Italian" },
          { id: "JA", title: "Japanese" },
          { id: "SV", title: "Swedish" },
          { id: "TR", title: "Turkish" },
         // { id: "AM", title: "Armenia" },
         // { id: "BY", title: "Belarus" },
         // { id: "EE", title: "Estonia" },
         // { id: "GE", title: "Georgia" },
          //{ id: "KG", title: "Kyrgyzstan" },
         // { id: "KZ", title: "Kazakhstan" },
        //  { id: "LT", title: "Lithuania" },
        //  { id: "LV", title: "Latvia" },
         // { id: "MD", title: "Moldova" },
          { id: "AZ", title: "Azerbaijan" },
          { id: "RU", title: "Russia" },
         // { id: "TJ", title: "Tajikistan" },
        //  { id: "TM", title: "Turkmenistan" },
          { id: "UA", title: "Ukraine" },
          { id: "HE", title: "Hebrew" },
          { id: "HI", title: "Hindi" },
          { id: "ZH", title: "Chinese" }
       //   { id: "UZ", title: "Uzbekistan" }
         // { id: "BY", title: "Belarus" },
        ]
      };

      service.GetLocalization = function (meta, id) {
        var url = '/sdp/v2/' + meta + '/' + id + '/localizations';
        var deferred = $q.defer();
        lh.common.request.get(url)
          .then(function (response) {
            deferred.resolve(response);
          }, function (reason) {
            reason.url = url;
            reason.data = data;
            deferred.reject(reason);
          });

        return deferred.promise;
      }

      service.PatchLocalization = function (meta, id, data) {
        var url = '/discovery:80' + '/sdp/v2/' + meta + '/' + id + '/localizations';
        var request = {};
        request.method = 'PUT';
        request.url = url;
        request.headers = {};
        request.headers['X-Auth-Token'] = lh.common.config.get('authToken');
        request.data = data;

        return $http(request);
      };

      return service;
    }]);
